import store from "src/Reducers/store";
import setCurrentPage from "src/Utils/setCurrentPage";

const previousPage = () => store.getState().appReducer.previousPage;

export const DATA_EV_DEMO_END = {
  title: "Scan to find out more about EdgeVerve",
  bgImage: "EV/EV_demo_Intro_09.png",
  image: "EV/EV_demo_end_QR.png",
  headerRightText: "GET THE EDGE",
  headerLeftImage: "EdgeverveLogo.png",
  headerRightTextStyle: { marginLeft: "85px" },
  optionsButtons: [
    {
      label: "back",
      onClick: () => setCurrentPage(previousPage()),
      type: "transparent",
      startIcon: "arrow-left",
    },
  ],
};
